import { dataEyedropper } from 'dls-icons-data'
import { createIcon } from '../common'

const IconEyedropper = /*#__PURE__*/createIcon(dataEyedropper)
export default IconEyedropper
